import { createSlice } from '@reduxjs/toolkit';
import { initStateLoginUser, reducerLoginUser } from '../actions/user/loginUser';
import { initStateCheckAccess, reducerCheckAccess } from '../actions/user/checkAccess';
import { initStateUpdateRefresh, reducerUpdateRefresh } from '../actions/user/updateRefresh';
import { initStateLogoutUser, reducerLogoutUser } from '../actions/user/logoutUser';
import { initStatechangePasswordUser, reducerchangePasswordUser } from '../actions/user/changePasswordUser';
import { initStateGetAdminList, reducerGetAdminList } from '../actions/user/getAdminList';
import { initStateGetManagerList, reducerGetManagerList } from '../actions/user/getManagerList';
import { initStateGetUserById, reducerGetUserById } from '../actions/user/getUserById';
import { initStateUpdateUser, reducerUpdateUser } from '../actions/user/updateUser';
import { initStateResetPasswordUser, reducerResetPasswordUser } from '../actions/user/resetPasswordUser';
import { initStateCreateUser, reducerCreateUser } from '../actions/user/createUser';
import { initStateUpdateEmailUser, reducerUpdateEmailUser } from '../actions/user/updateEmailUser';
import { initStateGetMe, reducerGetMe } from '../actions/user/getMe';
import { initStateGetUsers, reducerGetUsers } from '../actions/user/getUsers';
import { initStateGetUserStats, reducerGetUserStats } from '../actions/user/getUserStats';
import { initStateDeleteUserList, reducerDeleteUserList } from '../actions/user/deleteUserList';
import { initStateBlockUserList, reducerBlockUserList } from '../actions/user/blockUserList';
import { initStateEditComment, reducerEditComment } from '../actions/user/editComment';
import { initStateGetRolePermissions, reducerGetRolePermissions } from '../actions/user/getRolePermissions';
import { initStateGetUserPermissions, reducerGetUserPermissions } from '../actions/user/getUserPermissions';
import { initStateUpdateUserPermissions, reducerUpdateUserPermissions } from '../actions/user/updateUserPermissions';

export const initialState = {
  ...initStateLoginUser,
  ...initStateCheckAccess,
  ...initStateUpdateRefresh,
  ...initStateLogoutUser,
  ...initStatechangePasswordUser,
  ...initStateGetAdminList,
  ...initStateGetManagerList,
  ...initStateGetUserById,
  ...initStateUpdateUser,
  ...initStateResetPasswordUser,
  ...initStateCreateUser,
  ...initStateUpdateEmailUser,
  ...initStateGetMe,
  ...initStateGetUsers,
  ...initStateGetUserStats,
  ...initStateDeleteUserList,
  ...initStateBlockUserList,
  ...initStateEditComment,
  ...initStateGetRolePermissions,
  ...initStateGetUserPermissions,
  ...initStateUpdateUserPermissions,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    resetCheckAccess(state, action) {
      state.checkAccess = initialState.checkAccess;
    },
    resetUpdateRefresh(state, action) {
      state.updateRefresh = initialState.updateRefresh;
    },
    resetLoginUser(state, action) {
      state.loginUser = initialState.loginUser;
    },
    resetLogoutUser(state, action) {
      state.logoutUser = initialState.logoutUser;
    },
    resetChangePasswordUser(state, action) {
      state.changePasswordUser = initialState.changePasswordUser;
    },
    resetCreateUser(state, action) {
      state.createUser = initStateCreateUser.createUser;
    },
    resetGetUserById(state, action) {
      state.getUserById = initStateGetUserById.getUserById;
    },
    resetUpdateEmailUser(state, action) {
      state.updateEmailUser = initStateUpdateEmailUser.updateEmailUser;
    },
    resetUpdateUser(state, action) {
      state.updateUser = initStateUpdateUser.updateUser;
    },
    resetResetPasswordUser(state, action) {
      state.resetPasswordUser = initStateResetPasswordUser.resetPasswordUser;
    },
    resetGetUsers(state, action) {
      state.getUsers = initStateGetUsers.getUsers;
    },
    resetGetUserStats(state, action) {
      state.getUserStats = initStateGetUserStats.getUserStats;
    },
    resetDeleteUserList(state, action) {
      state.deleteUserList = initStateDeleteUserList.deleteUserList;
    },
    resetBlockUserList(state, action) {
      state.blockUserList = initStateBlockUserList.blockUserList;
    },
    resetEditComment(state, action) {
      state.editComment = initStateEditComment.editComment;
    },
    resetGetRolePermissions(state, action) {
      state.getRolePermissions = initStateGetRolePermissions.getRolePermissions;
    },
    resetGetUserPermissions(state, action) {
      state.getUserPermissions = initStateGetUserPermissions.getUserPermissions;
    },
    resetUpdateUserPermissions(state, action) {
      state.updateUserPermissions = initStateUpdateUserPermissions.updateUserPermissions;
    },
  },
  extraReducers: {
    ...reducerLoginUser,
    ...reducerCheckAccess,
    ...reducerUpdateRefresh,
    ...reducerLogoutUser,
    ...reducerchangePasswordUser,
    ...reducerGetAdminList,
    ...reducerGetManagerList,
    ...reducerGetUserById,
    ...reducerUpdateUser,
    ...reducerResetPasswordUser,
    ...reducerCreateUser,
    ...reducerUpdateEmailUser,
    ...reducerGetMe,
    ...reducerGetUsers,
    ...reducerGetUserStats,
    ...reducerDeleteUserList,
    ...reducerBlockUserList,
    ...reducerEditComment,
    ...reducerGetRolePermissions,
    ...reducerGetUserPermissions,
    ...reducerUpdateUserPermissions,
  },
});
export const {
  resetEditComment,
  resetBlockUserList,
  resetDeleteUserList,
  resetGetUserStats,
  resetGetUsers,
  resetResetPasswordUser,
  resetUpdateUser,
  resetUpdateEmailUser,
  resetGetUserById,
  resetCreateUser,
  resetCheckAccess,
  resetUpdateRefresh,
  resetLoginUser,
  resetLogoutUser,
  resetChangePasswordUser,
  resetGetRolePermissions,
  resetGetUserPermissions,
  resetUpdateUserPermissions,
} = userSlice.actions;
export const userReducer = userSlice.reducer;
